export default __webpack_public_path__ + "static/media/no-template.f5e6564f.png";